export default "__VITE_ASSET__5a4d0c3c__"